export interface FixedHeaderConfig {
    header: HTMLElement;
    content: HTMLElement;
}

export class FixedHeader {
    private readonly elements: {
        header: HTMLElement,
        content: HTMLElement
    };

    constructor(options: FixedHeaderConfig) {
        this.elements = options;
        this.init();
    }

    protected setFixedClass(): void {
        window.addEventListener('scroll', () => {
            let scrolled = (window.pageYOffset > this.headerHeight);
            scrolled
                ? this.elements.header.classList.add(`is-fixed`)
                : this.elements.header.classList.remove(`is-fixed`);
        });
    }

    public setContentPadding(): void {
        this.elements.content.style.paddingTop = `${this.headerHeight}px`;
    }

    protected init(): void {
        const {header} = this.elements;
        if (!header) return;

        const
            sticky = header.classList.contains(`is-sticky`),
            overlay = header.classList.contains(`use-overlay`);
        if (!sticky) return;

        if (overlay) {
            this.setFixedClass();
            return;
        }

        this.setContentPadding();
        this.setFixedClass();
        window.addEventListener('resize', (evt) => this.setContentPadding());
    }

    public get headerHeight(): number {
        return this.elements.header.clientHeight;
    }
}